import React from "react"
import Base from "./base"

// Components
import QuillInput from '@shared/quillInput'

export default class Observations extends Base {
  render() {
    const { quote, replaceQuote } = this.props
    const footer_info = quote.client.partner_pdf_footer_info || quote.account.pdf_footer_info
    return(
      <React.Fragment>
        <br/>
        {
          this.state.active
          ? <QuillInput text={quote.observations}
              onChange={content => replaceQuote({...quote, observations: content})}
              onBlur={this.deactivate}
              name="quote[observation]"
            />
          : <React.Fragment>
              <div onClick={this.activate}
                dangerouslySetInnerHTML={{__html: quote.observations || "-"}}
                className="no-margins quotes--form-pointer quotes--form-details"
              >
              </div>

              <input
                type="hidden"
                name="quote[observation]"
                defaultValue={quote.observations || ""}
              />
            </React.Fragment>
        }
        <div className="quotes--form-footer">
          <div className="company-name">
            {footer_info.account_name}
          </div>

          <div>
            {footer_info.account_address}
            &nbsp;-&nbsp;
            {footer_info.account_vat}
          </div>

          <div>
            {footer_info.account_phone}
            &nbsp;-&nbsp;
            {footer_info.account_mail}
            {footer_info.account_website && <>&nbsp;-&nbsp;{footer_info.account_website}</>}
          </div>
        </div>
      </React.Fragment>
    )
  }
}
